import * as React from 'react'
import styled from 'styled-components'

import GiftBoxIcon from 'app/components/SignupCampaign/icons/GiftBoxIcon'

interface IProps {
  onClick: () => void
}

const GiftButton: React.FC<IProps> = (props) => (
  <ButtonView className="target-gift-button" onClick={props.onClick}>
    <GiftBoxIcon />
  </ButtonView>
)

const ButtonView = styled.button`
  padding: 0;
  margin: 14px 20px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 999;
  width: 46px;
  height: 46px;
  border-radius: 23px;
  border: none;
  background-color: #4749d1;
  cursor: pointer;
`

export default GiftButton
